module.exports = __webpack_public_path__ + "static/media/github.d173c706.PNG";